var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBathroom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1112 19.1112H4.4445C1.99447 19.1112 0 17.1168 0 14.6667V10.6667H19.5555V14.6667C19.5555 17.1168 17.561 19.1112 15.1112 19.1112ZM0.888835 11.5556V14.6667C0.888835 16.6278 2.4834 18.2223 4.4445 18.2223H15.1112C17.0723 18.2223 18.6667 16.6278 18.6667 14.6667V11.5556H0.888835Z",
    fill: "#646262"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 18.6667H6.22233V20.0001H5.3335V18.6667Z",
    fill: "#646262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 18.6667H14.2223V20.0001H13.3335V18.6667Z",
    fill: "#646262"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55534 11.1112H2.6665V3.11117C2.6665 1.39437 4.06087 0 5.77767 0C7.4943 0 8.88867 1.39437 8.88867 3.11117V3.5555H7.99984V3.11117C7.99984 1.8833 7.00537 0.888835 5.77767 0.888835C4.5498 0.888835 3.55534 1.8833 3.55534 3.11117V11.1112Z",
    fill: "#646262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5557 7.11108H5.3335V6.22209C5.3335 4.50545 6.72786 3.11108 8.44466 3.11108C10.1613 3.11108 11.5557 4.50545 11.5557 6.22209V7.11108ZM6.22233 6.22209H10.6668C10.6668 4.99439 9.67236 3.99992 8.44466 3.99992C7.2168 3.99992 6.22233 4.99439 6.22233 6.22209Z",
    fill: "#646262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBathroom);
export default __webpack_public_path__ + "static/media/icon-bathroom.c0c8f11280ae21ddadbfbc1e9d5d3b96.svg";
export { ForwardRef as ReactComponent };